import { render, staticRenderFns } from "./ComplexPage.vue?vue&type=template&id=5be77f57&scoped=true&lang=pug&"
import script from "./ComplexPage.vue?vue&type=script&lang=js&"
export * from "./ComplexPage.vue?vue&type=script&lang=js&"
import style0 from "./ComplexPage.vue?vue&type=style&index=0&id=5be77f57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be77f57",
  null
  
)

export default component.exports